export function getDateTime(date: Date, isDontNeedHour?: boolean) {
    let day: string | number = date.getDate();
    if (day < 10) day = '0' + day;

    let month: string | number = date.getMonth() + 1;
    if (month < 10) month = '0' + month;

    let year: string | number = date.getFullYear();


    let hour: string | number = date.getHours();
    if (hour < 10) hour = '0' + hour;

    let minute: string | number = date.getMinutes();
    if (minute < 10) minute = '0' + minute;

    const result = isDontNeedHour
        ? day + '.' + month + '.' + year
        : day + '.' + month + '.' + year + ' ' + hour + ':' + minute;

    return result;
}

export function getIsExpired(receivingDate: string) {
    const receivingDateAsDate = new Date(receivingDate);

    const today = new Date();

    today.setHours(0, 0, 0, 0);

    const threeDaysAgo = new Date(today);
    threeDaysAgo.setDate(today.getDate() - 3);

    return receivingDateAsDate < threeDaysAgo;
}
